import gql from 'graphql-tag';

export const mutationViewIntegrationItem = gql`
  mutation viewIntegrationItem (
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    viewIntegrationItem (
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
export default mutationViewIntegrationItem;
